import * as yup from 'yup';

const amountSchema = yup.object().shape({
  amount: yup.string().required('Mandatory amount field!')
});

export { amountSchema };
